import { FeatureFlag } from '../FeatureFlag';

export const showLegacyLocatesWidgetBlocker = new FeatureFlag({
    key: 'show-legacy-locates-widget-blocker',
    createdOn: '2026-09-27',
    defaultValue: true,
});
